import { faqItems } from '@/mocks/homepage';
import { useState } from 'react';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-600">关于春夜影院，你可能想了解的都在这里</p>
        </div>
        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqItems.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div
                key={faq.id}
                className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() => toggle(faq.id)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm md:text-base font-medium text-foreground-950 pr-4">{faq.question}</h3>
                  <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                    isOpen ? "rotate-180" : ""
                  }`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </span>
                </button>
                <div
                  className={`px-5 transition-all duration-300 overflow-hidden ${
                    isOpen ? "pb-5 max-h-96" : "max-h-0"
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}